import { defineMessages } from 'react-intl';

type MessageKeys = 'screenReaderPrompt';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		screenReaderPrompt: {
			id: 'rovo-chat.search-input.screen-reader-prompt',
			defaultMessage: 'Typing any character in this field will update the search results below',
			description: 'Screen reader prompt for the search input',
		},
	});

export default message;
